import React from "react";
import { Activity } from "lucide-react";

const NEON = { green: "#22E0A1", amber: "#FFD54A", red: "#FF6B85" };
// One 120px-wide heartbeat segment (viewBox 120x64, baseline y=32)
const PATH = "M0 32 H28 L34 32 L40 12 L48 52 L54 32 L72 32 L88 32 L94 32 L100 20 L106 46 L112 32 H120";

const MoodPulse = ({ mood, loading }) => {
  const dial = mood?.dial || "amber";
  const c = NEON[dial] || NEON.amber;
  const score = mood?.score ?? "—";
  // lower mood => faster, more agitated pulse
  const dur = mood ? Math.max(2.0, 5.6 - (mood.score / 100) * 3.6) : 4;

  return (
    <section className="mt-7" data-testid="mood-pulse">
      <h3 className="font-head mb-3 text-sm font-bold uppercase tracking-wide text-slate-400">Nation Mood Pulse</h3>

      <div className="relative overflow-hidden rounded-[1.75rem] p-5" style={{ background: "linear-gradient(158deg,#123081 0%,#06133A 100%)", boxShadow: "0 12px 34px rgba(10,42,107,0.35)" }}>
        <div className="go-ekg-grid absolute inset-0 opacity-70" />

        <div className="relative flex items-start justify-between">
          <div>
            <div className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-white/60">
              <Activity size={13} color={c} /> Island sentiment
            </div>
            <div className="font-head mt-1 text-4xl font-extrabold leading-none text-white" data-testid="mood-score">{score}</div>
            <div className="mt-1 text-sm font-bold" style={{ color: c }}>{mood?.label || (loading ? "Reading…" : "Steady")}</div>
          </div>
          <span className="flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1 text-[11px] font-semibold text-white/85">
            <span className="go-blip inline-block h-2 w-2 rounded-full" style={{ background: c, boxShadow: `0 0 8px ${c}` }} /> Live
          </span>
        </div>

        <div className="relative mt-3 h-16">
          <div className="go-ekg-track h-16" style={{ animationDuration: `${dur}s` }}>
            {Array.from({ length: 12 }).map((_, i) => (
              <svg key={i} viewBox="0 0 120 64" width="120" height="64" preserveAspectRatio="none" style={{ flex: "0 0 auto" }}>
                <path d={PATH} fill="none" stroke={c} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" style={{ filter: `drop-shadow(0 0 5px ${c})` }} />
              </svg>
            ))}
          </div>
          {/* leading edge glow */}
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16" style={{ background: "linear-gradient(90deg, transparent, #06133A)" }} />
        </div>

        <div className="relative mt-1 text-[11px] text-white/55">Live sentiment fused across the island · updates continuously</div>
      </div>
    </section>
  );
};

export default MoodPulse;
